var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4E592;}\n\t.st1{fill:#9DCEE3;}\n\t.st2{fill:#C2E5F0;}\n\t.st3{fill:#E6E7E8;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#A22646;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 100,
    cy: 100,
    r: 99.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.6,47.4c13.6,0,26.4,3,37.9,8.5c-15.4-27-44.3-45.1-77.6-45.1c-49.3,0-89.3,40-89.3,89.3 c0,35.7,21,66.5,51.3,80.8c-7.4-13-11.7-28.1-11.7-44.1C50.4,87.4,90.3,47.4,139.6,47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M189.3,100c0-16.1-4.3-31.1-11.7-44.1c-11.5-5.4-24.4-8.5-37.9-8.5c-49.3,0-89.3,40-89.3,89.3 c0,16.1,4.3,31.1,11.7,44.1c11.5,5.4,24.4,8.5,37.9,8.5C149.3,189.3,189.3,149.3,189.3,100z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 31.3,
    y: 67.4,
    className: "st3",
    width: 137.5,
    height: 65.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.3,
    y: 63.2,
    className: "st4",
    width: 111.5,
    height: 73.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 100,
    cy: 100,
    r: 26.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "113.4,100 93.8,86.7 93.8,113.3  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoLibrary);
export default __webpack_public_path__ + "static/media/video_library.17b439d23c76274bdf01f11234902bce.svg";
export { ForwardRef as ReactComponent };